/**
 * Sort option values match the existing web SortDifferencesOption enum in
 * apps/web/src/types/inspection.ts. Defined here as the single source of truth
 * so both apps use the same typed values without string drift.
 */
export var SortDifferencesOption;
(function (SortDifferencesOption) {
    SortDifferencesOption["readingOrder"] = "order";
    SortDifferencesOption["differenceType"] = "type";
    SortDifferencesOption["differenceStatus"] = "status";
    SortDifferencesOption["fontSize"] = "fontSize";
    SortDifferencesOption["alphabetical"] = "alphabetical";
})(SortDifferencesOption || (SortDifferencesOption = {}));
/**
 * Module identity used for per-module partitioning, sorting, and numbering.
 */
export var DifferenceModule;
(function (DifferenceModule) {
    DifferenceModule["text"] = "Text";
    /** TextMatch has no difference card or report section. Use isIgnoredCtfDifference to pre-filter these rows before passing to fromCtfDifference or computeDifferenceNumbering. */
    DifferenceModule["textMatch"] = "TextMatch";
    DifferenceModule["spelling"] = "Spelling";
    DifferenceModule["graphics"] = "Graphics";
    DifferenceModule["barcode"] = "Barcode";
    DifferenceModule["braille"] = "Braille";
    DifferenceModule["fontMetrics"] = "FontMetrics";
    DifferenceModule["color"] = "Color";
    DifferenceModule["markup"] = "Markup";
})(DifferenceModule || (DifferenceModule = {}));
//# sourceMappingURL=difference.js.map